export enum ActionListNavBlock {
  Root = 'ActionListNav',
}

export enum ActionListNavElement {
  NoData = 'noData',
}
